// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1aidM","tab":"Tabs_tab__qb_ft","tabActive":"Tabs_tabActive__LSKQo"};